export const INPAGE_ERROR_CHARTS = [
  "vs-purchase-without",
  "vs-sales-without",
  "vs-purchase-clicks",
  "vs-sales-clicks",
  "vs-purchase-without-share-rate",
  "vs-sales-without-share-rate",
  "vs-without-purchase-rate",
  "vs-purchase-clicks-share-rate",
  "vs-sales-clicks-share-rate",
  "vs-clicks-purchase-rate",
  "vs-sales-comparisons-share-rate",
];

export const FIT_ILLUSTRATOR_ERROR_CHARTS = [
  "vs-recommendations",
  "vs-recommendation-rate",
  "vs-sales-without",
  "vs-purchase-without",
  "vs-sales-recommendations",
  "vs-purchase-recommendations",
  "vs-purchase-without-share-rate",
  "vs-sales-without-share-rate",
  "vs-without-purchase-rate",
  "vs-purchase-recommendations-share-rate",
  "vs-sales-recommendations-share-rate",
  "vs-recommendations-purchase-rate",
];

export const SMART_TABLE_ERROR_CHARTS = [
  "vs-recommendations",
  "vs-recommendation-rate",
  "vs-sales-without",
  "vs-purchase-without",
  "vs-sales-recommendations",
  "vs-purchase-recommendations",
  "vs-purchase-without-share-rate",
  "vs-sales-without-share-rate",
  "vs-without-purchase-rate",
  "vs-purchase-recommendations-share-rate",
  "vs-sales-recommendations-share-rate",
  "vs-recommendations-purchase-rate",
];

export const RATE_ERROR_CHARTS = [
  "vs-recommendation-rate",
  "vs-recommendations-purchase-rate",
  "unique-vs-recommendation-rate",
  "unique-vs-recommendations-purchase-rate",
];
